import React from 'react';
import { CircularProgress } from '@mui/material';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CustomMonthDatePicker from '../../../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';
import CustomYearDatePicker from '../../../Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker';
import { XtramButton, XtramField } from '../../../Widgets/XtramModal/XtramModal';
import styles from './WithholdingModal.module.scss';

export const ReportTypePicker = ({ t, types, value, onChange }) => (
    <div className={styles.controlsRow}>
        <span className={styles.controlsLabel}>{t('SelectReportType')}</span>
        <div className={styles.typeGroup} role="radiogroup" aria-label={t('SelectReportType')}>
            {types.map((type) => (
                <XtramButton
                    key={type.value}
                    variant="ghost"
                    small
                    role="radio"
                    aria-checked={value === type.value}
                    active={value === type.value}
                    onClick={() => onChange(type.value)}
                >
                    {t(type.label)}
                </XtramButton>
            ))}
        </div>
    </div>
);

export const PeriodFields = ({ t, isDateRange, startDate, endDate, setStartDate, setEndDate, date, setDate }) => (
    isDateRange ? (
        <>
            <XtramField label={t('StartDate')} className={styles.dateField}>
                <CustomMonthDatePicker onDateChange={setStartDate} date={startDate} height="40px" />
            </XtramField>
            <XtramField label={t('EndDate')} className={styles.dateField}>
                <CustomMonthDatePicker onDateChange={setEndDate} date={endDate} height="40px" />
            </XtramField>
        </>
    ) : (
        <XtramField label={t('date')} className={styles.dateField}>
            <CustomYearDatePicker onDateChange={setDate} date={date} height="40px" />
        </XtramField>
    )
);

export const ReportPreview = ({ t, html, loading, title, sandbox, onLoad }) => (
    <div className={styles.preview}>
        {html ? (
            <iframe srcDoc={html} title={title} sandbox={sandbox} onLoad={onLoad} className={styles.frame} />
        ) : (
            <div className={styles.empty}>
                <span className={styles.emptyIcon}><AssessmentOutlinedIcon /></span>
                <h3 className={styles.emptyTitle}>{t('Reports')}</h3>
                <p className={styles.emptyText}>{t('SelectReportTypeFirstly')}</p>
            </div>
        )}
        {loading && (
            <div className={styles.previewLoading}>
                <CircularProgress size={32} />
            </div>
        )}
    </div>
);
